import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class RXNormService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getRXNormCodesFromText(descriptionText) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/rxnorm?searchText=${descriptionText}`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getRXNormRelatedCodes(medicationCodes) {
        const response = await axios.post(`${this.environment.API_BASE_URL}/rxnorm_related`, { medicationCodes }, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
